import type { Layer, TagsManager } from 'dxf-writer'
import DatabaseObject from 'dxf-writer/src/DatabaseObject.js'

/**
 * DXF 轻量多段线（LWPOLYLINE）实体，支持闭合、起止线宽与凸度。
 */
export default class Polyline extends DatabaseObject {
  /** 所属图层 */
  layer!: Layer
  /** 线型名称，默认跟随图层 */
  lineType: string = 'ByLayer'
  /** 线宽，单位百分之毫米；-1 表示跟随图层 */
  lineWidth: number = -1
  /** 真彩色 RGB 整数，undefined 表示不写入 */
  trueColor: number | undefined

  /**
   * @param {array} points - Array of points like [ [x1, y1], [x2, y2, bulge]... ]
   * @param {boolean} closed
   * @param {number} startWidth
   * @param {number} endWidth
   */
  constructor(
    public points: Array<[number, number, number?]>,
    public closed: boolean = false,
    public startWidth: number = 0,
    public endWidth: number = 0
  ) {
    super(['AcDbEntity', 'AcDbPolyline'])
  }

  /**
   * 写入 LWPOLYLINE 组码序列。
   *
   * @param manager - DXF 标签写入器
   */
  tags(manager: TagsManager): void {
    manager.push(0, 'LWPOLYLINE')
    super.tags(manager)
    manager.push(8, this.layer.name)
    manager.push(6, this.lineType)
    manager.push(62, 256)
    manager.push(370, this.lineWidth)
    if (this.trueColor !== undefined) {
      manager.push(420, this.trueColor)
    }
    manager.push(90, this.points.length)
    manager.push(70, this.closed ? 1 : 0)

    this.points.forEach((point) => {
      const [x, y, z] = point
      manager.push(10, x)
      manager.push(20, y)
      if (this.startWidth !== 0 || this.endWidth !== 0) {
        manager.push(40, this.startWidth)
        manager.push(41, this.endWidth)
      }
      if (z !== undefined) manager.push(42, z)
    })
  }
}
